import { Flex, Text, type FlexProps, type SelectProps } from '@mantine/core';
import classes from './FormRegionsSelect.module.scss';
import { RegionsSelect } from '@entities/region';

interface FormRegionsSelectProps extends SelectProps {
  title?: string;
  description?: string;
  containerProps?: FlexProps;
}

export const FormRegionsSelect = ({
  title = 'Город',
  description = 'В каком городе предстоит работать',
  containerProps,
  ...props
}: FormRegionsSelectProps) => {
  return (
    <Flex gap='24' className={classes.formRow} {...containerProps}>
      <Flex direction='column' gap={6} className={classes.leftColumn}>
        <Text className={classes.title}>{title}</Text>
        <Text className={classes.description}>{description}</Text>
      </Flex>

      <RegionsSelect
        {...props}
        className={classes.rightColumn}
        variant='filled'
      />
    </Flex>
  );
};
